module.exports = __webpack_public_path__ + "img/banner3_3_jp.38b2f874.png";